(function () {
  var ROOT_SELECTOR = '[data-auxito-blog-article]';
  var PENDING_KEY = '__auxitoBlogPagesPending';
  var STATE_KEY = '__auxitoBlogPagesState';
  var api = window.AuxitoBlogPages = window.AuxitoBlogPages || {};

  if (api.lifecycleBound) {
    api.initAll(document);
    return;
  }

  api.lifecycleBound = true;
  api.enhanceArticleBody = enhanceArticleBody;
  api.initAll = initAll;
  api.destroyAll = destroyAll;

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  function collectRoots(scope) {
    var roots = [];
    var searchScope = scope || document;

    if (searchScope.matches && searchScope.matches(ROOT_SELECTOR)) {
      roots.push(searchScope);
    }
    if (searchScope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(searchScope.querySelectorAll(ROOT_SELECTOR)));
    }

    return roots;
  }

  function initAll(scope) {
    collectRoots(scope).forEach(initRoot);
  }

  function destroyAll(scope) {
    collectRoots(scope).forEach(destroyRoot);
  }

  function initRoot(root) {
    if (root[STATE_KEY]) return;

    var body = root.querySelector('[data-auxito-article-body]');
    var tocs = Array.prototype.slice.call(root.querySelectorAll('[data-auxito-article-toc]'));
    var tocPanels = tocs.map(function (toc) {
      return toc.closest('.auxito-blog-toc');
    }).filter(Boolean);
    if (!body || !tocs.length || !tocPanels.length) {
      observePendingRoot(root);
      return;
    }

    clearPendingRoot(root);

    var state = {
      fitmentHandlers: [],
      headingIds: [],
      hiddenTocPanels: [],
      links: [],
      observer: null
    };
    root[STATE_KEY] = state;

    setupFitmentTriggers(root, state);

    enhanceArticleBody(body);

    var headings = getTocHeadings(body);
    if (headings.length < 2) {
      tocPanels.forEach(function (panel) {
        panel.hidden = true;
        state.hiddenTocPanels.push(panel);
      });
      return;
    }

    var usedIds = {};
    headings.forEach(function (heading, index) {
      var base = heading.textContent.trim().toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'section';
      var requestedId = heading.id || 'article-' + base;
      var id = requestedId;
      var suffix = 2;
      while (usedIds[id] || (document.getElementById(id) && document.getElementById(id) !== heading)) {
        id = requestedId + '-' + suffix;
        suffix += 1;
      }
      usedIds[id] = true;
      state.headingIds.push({ heading: heading, id: heading.id });
      heading.id = id;

      var headingText = normalizeTocText(heading.textContent);
      tocs.forEach(function (toc) {
        var link = document.createElement('a');
        var number = document.createElement('span');
        var label = document.createElement('span');
        link.href = '#' + id;
        number.textContent = (index + 1) + '. ';
        label.textContent = headingText;
        link.appendChild(number);
        link.appendChild(label);
        link.addEventListener('click', function (event) {
          event.preventDefault();
          state.links.forEach(function (item) {
            item.classList.toggle('is-active', item.getAttribute('href') === '#' + id);
          });
          var header = document.querySelector('#shopify-section-static-header');
          var offset = header ? header.offsetHeight + 18 : 96;
          var top = heading.getBoundingClientRect().top + window.pageYOffset - offset;
          var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: top, behavior: reducedMotion ? 'auto' : 'smooth' });
          history.replaceState(null, '', '#' + id);
        });
        toc.appendChild(link);
        state.links.push(link);
      });
    });

    state.links[0].classList.add('is-active');
    if (!('IntersectionObserver' in window)) return;

    state.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        state.links.forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
        });
      });
    }, {
      rootMargin: '-25% 0px -65% 0px',
      threshold: 0
    });

    headings.forEach(function (heading) {
      state.observer.observe(heading);
    });
  }

  function destroyRoot(root) {
    clearPendingRoot(root);

    var state = root[STATE_KEY];
    if (!state) return;

    if (state.observer) {
      state.observer.disconnect();
    }
    state.fitmentHandlers.forEach(function (item) {
      item.trigger.removeEventListener('click', item.click);
      item.trigger.removeEventListener('keydown', item.keydown);
    });
    state.links.forEach(function (link) {
      if (link.parentNode) link.parentNode.removeChild(link);
    });
    state.hiddenTocPanels.forEach(function (panel) {
      panel.hidden = false;
    });
    state.headingIds.forEach(function (item) {
      if (item.id) {
        item.heading.id = item.id;
      } else {
        item.heading.removeAttribute('id');
      }
    });

    delete root[STATE_KEY];
  }

  function observePendingRoot(root) {
    if (root[PENDING_KEY] || !('MutationObserver' in window)) return;

    var observer = new window.MutationObserver(function () {
      initRoot(root);
    });
    root[PENDING_KEY] = observer;
    observer.observe(root, { childList: true, subtree: true });
  }

  function clearPendingRoot(root) {
    var observer = root[PENDING_KEY];
    if (!observer) return;

    observer.disconnect();
    delete root[PENDING_KEY];
  }

  function setupFitmentTriggers(scope, state) {
    Array.prototype.slice.call(scope.querySelectorAll('[data-auxito-fitment-modal-trigger]')).forEach(function (trigger) {
      var clickHandler = function (event) {
        openVehicleSelector(event);
      };

      var keydownHandler = function (event) {
        if (event.key !== ' ' && event.key !== 'Spacebar') return;
        if (openVehicleSelector(event)) return;

        event.preventDefault();
        window.location.assign(trigger.href);
      };

      trigger.addEventListener('click', clickHandler);
      trigger.addEventListener('keydown', keydownHandler);
      state.fitmentHandlers.push({
        trigger: trigger,
        click: clickHandler,
        keydown: keydownHandler
      });
    });
  }

  function openVehicleSelector(event) {
    var vehicleApi = window.Auxito && window.Auxito.Vehicle && window.Auxito.Vehicle.Selector;
    var modal = document.getElementById('vehicleModal');
    if (!modal || !vehicleApi || typeof vehicleApi.openModal !== 'function') return false;

    try {
      vehicleApi.openModal({ source: 'fitment' });
      event.preventDefault();
      return true;
    } catch (error) {
      return false;
    }
  }

  function normalizeTocText(text) {
    return (text || '')
      .replace(/\s+/g, ' ')
      .replace(/^\s*\d+[\.\)]\s*/, '')
      .trim();
  }

  function getTocHeadings(articleBody) {
    var h2s = filterTocHeadings(articleBody.querySelectorAll('h2'));
    if (h2s.length >= 5) return h2s;

    var mixed = filterTocHeadings(articleBody.querySelectorAll('h2, h3'));
    return mixed.slice(0, 6);
  }

  function filterTocHeadings(nodeList) {
    return Array.prototype.slice.call(nodeList).filter(function (heading) {
      if (heading.closest('.left-main-content')) return false;
      if (heading.closest('[hidden], [aria-hidden="true"]')) return false;
      if (window.getComputedStyle(heading).display === 'none') return false;

      var text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^(content|cover)\s*:?\s*$/i.test(text)) return false;
      if (heading.tagName === 'H3' && (text.length > 80 || /[.!?]\s*$/.test(text))) return false;

      return text.length > 0;
    });
  }

  function enhanceArticleBody(articleBody) {
    removeLegacyHeadings(articleBody);
    numberArticleSections(articleBody);
    enhanceLegacyImageTables(articleBody);
    enhanceLegacyDataTables(articleBody);
    enhanceLegacyChartImages(articleBody);
    enhanceCallouts(articleBody);
    enhanceKeyTakeaways(articleBody);
  }

  function removeLegacyHeadings(articleBody) {
    Array.prototype.slice.call(articleBody.querySelectorAll('h2, h3')).forEach(function (heading) {
      var text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^(content|cover)\s*:?\s*$/i.test(text)) {
        heading.remove();
      }
    });
  }

  function numberArticleSections(articleBody) {
    var index = 0;
    Array.prototype.slice.call(articleBody.querySelectorAll('h2')).forEach(function (heading) {
      if (heading.closest('[hidden], [aria-hidden="true"]')) return;
      if (window.getComputedStyle(heading).display === 'none') return;

      var text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || /^\d+[\.\)]\s*/.test(text)) return;
      if (/^(content|cover)\s*:?\s*$/i.test(text)) return;

      index += 1;
      heading.classList.add('auxito-blog-numbered-heading');
      heading.setAttribute('data-section-number', index);
    });
  }

  function enhanceCallouts(articleBody) {
    Array.prototype.slice.call(articleBody.querySelectorAll('p, blockquote')).forEach(function (node) {
      if (node.closest('.tip, .note, .fix-it-right, .blue-note, .info-note, .key-takeaways, .takeaways')) return;

      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      if (/^(fix it right|fix-it-right)\b/i.test(text)) {
        node.classList.add('fix-it-right');
        return;
      }

      if (/^(tip|pro tip)\b[:：-]?/i.test(text)) {
        node.classList.add('tip');
        return;
      }

      if (/^(note|important)\b[:：-]?/i.test(text)) {
        node.classList.add('note');
      }
    });
  }

  function enhanceKeyTakeaways(articleBody) {
    Array.prototype.slice.call(articleBody.querySelectorAll('h2, h3')).forEach(function (heading) {
      if (heading.closest('.key-takeaways, .takeaways')) return;
      if (!/\bkey\s+takeaways?\b|\btakeaways?\b/i.test(heading.textContent || '')) return;

      var list = nextMeaningfulElement(heading);
      if (!list || !/^(UL|OL)$/.test(list.tagName)) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'key-takeaways';
      heading.parentNode.insertBefore(wrapper, heading);
      wrapper.appendChild(heading);
      wrapper.appendChild(list);
    });
  }

  function enhanceLegacyImageTables(articleBody) {
    Array.prototype.slice.call(articleBody.querySelectorAll('table')).forEach(function (table) {
      if (table.classList.contains('auxito-blog-image-table')) return;
      if (table.querySelector('th')) return;

      var text = (table.textContent || '').replace(/\s+/g, '').trim();
      var images = table.querySelectorAll('img');
      var cells = Array.prototype.slice.call(table.querySelectorAll('td'));
      var isImageOnlyTable = !text &&
        images.length >= 2 &&
        images.length <= 6 &&
        cells.length === images.length &&
        cells.every(function (cell) {
          return !cell.hasAttribute('colspan') &&
            !cell.hasAttribute('rowspan') &&
            cell.querySelectorAll('img').length === 1;
        });
      var isWideLinkedImageTable = !text &&
        images.length > 6 &&
        images.length <= 12 &&
        cells.length === images.length &&
        cells.every(function (cell) {
          var link = cell.firstElementChild;
          return !cell.hasAttribute('colspan') &&
            !cell.hasAttribute('rowspan') &&
            cell.children.length === 1 &&
            link &&
            link.tagName === 'A' &&
            link.children.length === 1 &&
            link.firstElementChild.tagName === 'IMG';
        });

      if (!isImageOnlyTable && !isWideLinkedImageTable) return;

      table.classList.add('auxito-blog-image-table');
      if (isWideLinkedImageTable) {
        table.classList.add('auxito-blog-image-table--wide');
      }

      var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
      var columnCount = rows.reduce(function (maximum, row) {
        return Math.max(maximum, row.cells.length);
      }, 1);
      table.style.setProperty('--auxito-blog-image-columns', Math.min(columnCount, 4));

      cells.forEach(function (cell) {
        if (cell.querySelector('img')) {
          cell.classList.add('auxito-blog-image-table__cell');
        }
      });
    });
  }

  function enhanceLegacyDataTables(articleBody) {
    Array.prototype.slice.call(articleBody.querySelectorAll('table:not(.auxito-blog-image-table)')).forEach(function (table) {
      if (table.classList.contains('auxito-blog-data-table')) return;

      var columnCount = Array.prototype.slice.call(table.querySelectorAll('tr')).reduce(function (maximum, row) {
        return Math.max(maximum, row.cells.length);
      }, 1);
      var minimumWidth = Math.min(Math.max(columnCount * 112, 520), 960);

      table.classList.add('auxito-blog-data-table');
      table.style.setProperty('--auxito-blog-data-table-min-width', minimumWidth + 'px');

      var existingScroller = table.closest('.auxito-blog-table-scroll, .comparison-table, .comparison-table-re, .bulb-suit-wrapper');
      if (existingScroller && existingScroller !== table) {
        existingScroller.classList.add('auxito-blog-table-scroll');
        if (!existingScroller.hasAttribute('role')) {
          existingScroller.setAttribute('role', 'region');
        }
        if (!existingScroller.hasAttribute('aria-label')) {
          existingScroller.setAttribute('aria-label', 'Scrollable data table');
        }
        if (!existingScroller.hasAttribute('tabindex')) {
          existingScroller.setAttribute('tabindex', '0');
        }
        return;
      }

      var wrapper = document.createElement('div');
      wrapper.className = 'auxito-blog-table-scroll';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', 'Scrollable data table');
      wrapper.setAttribute('tabindex', '0');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  function enhanceLegacyChartImages(articleBody) {
    Array.prototype.slice.call(articleBody.querySelectorAll('img')).forEach(function (image) {
      if (image.closest('.auxito-blog-image-table')) return;

      var descriptor = [
        image.getAttribute('alt'),
        image.getAttribute('title'),
        image.getAttribute('src')
      ].join(' ').toLowerCase();
      if (!/(chart|comparison|table)/.test(descriptor)) return;

      image.classList.add('auxito-blog-chart-image');

      var wrapper = image.closest('p, figure, div');
      if (wrapper && wrapper !== articleBody && wrapper.closest('[data-auxito-article-body]')) {
        wrapper.classList.add('auxito-blog-chart-figure');
      }
    });
  }

  function nextMeaningfulElement(node) {
    var next = node.nextElementSibling;
    while (next && !(next.textContent || '').trim() && next.children.length === 0) {
      next = next.nextElementSibling;
    }
    return next;
  }
})();
